import { Roles } from "../Enums"

export class ProfiControlUserDto {
    public id: number | undefined = undefined;    
    public userName: string | undefined = undefined;
    public password: string | undefined = undefined;
    public firstName: string | undefined = undefined;
    public lastName: string | undefined = undefined;
    public description: string | undefined = undefined;
    public isSystemUser: boolean | undefined = false;
    public certificateId: number| undefined = undefined;
    public role: Roles | Roles = Roles.None;
}